import { useRoutes } from "react-router-dom";
import ChecklistBinding from "./component/checklistBinding";
import BindingReport from "./component/bindingReport";
import BindingAnalysis from "./component/bindingAnalysis";

const ChecklistBindingIndex = () => {
  const router = useRoutes([
    { index: true, element: <ChecklistBinding /> },
    { path: "report/:uuid", element: <BindingReport /> },
    { path: "analysis/:uuid", element: <BindingAnalysis /> },
  ]);
  return <div>{router}</div>;
};

export default ChecklistBindingIndex;